import { LodashExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../../models/fact-mapping.interface';
import { FactExtractor } from '../../fact-extractor';

export const TOO_MANY_HOLDINGS_FACTS: { [factName: string]: FactMappingInterface } = {
	numberOfHoldings: {
		// filter on ETFs/mutual funds
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return children.filter(child => child.legalType === 'ASSET_LEGAL_TYPE_ETF' || child.legalType === 'ASSET_LEGAL_TYPE_OPEN_END').length;
		})
	},

	numberOfETFs: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return children.filter(child => child.legalType === 'ASSET_LEGAL_TYPE_ETF').length;
		})
	},

	numberOfMutualFunds: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return children.filter(child => child.legalType === 'ASSET_LEGAL_TYPE_OPEN_END').length;
		})
	}
};
